"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureActionType = exports.FeatureCode = void 0;
var FeatureCode;
(function (FeatureCode) {
    FeatureCode["VOUCHER"] = "voucher";
    FeatureCode["JOB"] = "job";
    FeatureCode["USER"] = "user";
    FeatureCode["ROLE"] = "role";
    FeatureCode["RULE"] = "rule";
    FeatureCode["FORMAT"] = "format";
    FeatureCode["FIELD"] = "field";
    FeatureCode["MODIFICATION"] = "modification";
    FeatureCode["PARTNER"] = "partner";
    FeatureCode["ACCOUNTING_TYPE"] = "accountingType";
    FeatureCode["TAX_DIV"] = "taxDiv";
    FeatureCode["RECIPIENT"] = "recipient";
    FeatureCode["INPUT"] = "input";
    FeatureCode["API"] = "api";
    FeatureCode["DEPARTMENT"] = "department";
    FeatureCode["TENANT"] = "tenant";
    FeatureCode["EXPRESS_CONFIG"] = "expressConfig";
    FeatureCode["LOGIN_LOG_FOR_ADMIN"] = "loginLogForAdmin";
    FeatureCode["DASHBOARD"] = "dashboard";
    FeatureCode["INPUT_MANAGEMENT"] = "inputManagement";
    FeatureCode["EXPORTER"] = "exporter";
    FeatureCode["EXTERNAL_MAPPING"] = "externalMapping";
    FeatureCode["VOUCHER_MAPPING"] = "voucherMapping";
    FeatureCode["MASTER_FORMAT"] = "masterFormat";
    FeatureCode["INBOX"] = "inbox";
    FeatureCode["IP_RESTRICTION"] = "ipRestriction";
    FeatureCode["USAGE_REPORT"] = "usageReport";
    FeatureCode["FILTERING"] = "filtering";
    FeatureCode["PARTNER_FIELD"] = "partnerField";
})(FeatureCode = exports.FeatureCode || (exports.FeatureCode = {}));
var FeatureActionType;
(function (FeatureActionType) {
    FeatureActionType["READ"] = "read";
    FeatureActionType["WRITE"] = "write";
})(FeatureActionType = exports.FeatureActionType || (exports.FeatureActionType = {}));
